<template>
  <nuxt-link
    v-if="hasNextPage"
    ref="link"
    class="btn-pill-outline-black m-4"
    :class="{ 'pointer-events-none': loading }"
    :to="routeTo"
    data-testid="btn-product-grid-load-more"
    @click="observe"
    >{{ $t('collection.loadMore') }}</nuxt-link
  >
</template>

<script>
import { isElement } from '@/utils/common';
import { Bus } from '@/utils/bus';

export default defineNuxtComponent({
  props: {
    collection: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    hasNextPage() {
      return this.collection?.products?.pageInfo?.hasNextPage;
    },
    routeTo() {
      const { collectionProductsPerPage } = this.$config.public;
      return { query: { limit: this.productCount + collectionProductsPerPage } };
    },
    productCount() {
      return this.collection?.products?.edges.length || 0;
    },
  },
  watch: {
    productCount() {
      this.resetObserve();
    },
  },
  mounted() {
    // trigger click if window scrollposition is one window-height away
    this.mountObserver();
    this.observe();
    Bus.on('disable-infinity-loading', this.unobserve);
  },
  beforeUnmount() {
    Bus.off('disable-infinity-loading', this.unobserve);
    this.observer.disconnect();
  },
  methods: {
    mountObserver() {
      const options = {
        rootMargin: `${window.innerHeight * 1.5}px`,
        threshold: 0.1,
      };
      const callback = (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && this.hasNextPage) {
            navigateTo(this.routeTo, { replace: true });
          }
        });
      };
      this.observer = new IntersectionObserver(callback, options);
    },
    observe() {
      if (this.hasNextPage && isElement(this.$el)) this.observer.observe(this.$el);
    },
    unobserve() {
      if (isElement(this.$el)) this.observer.unobserve(this.$el);
    },
    resetObserve() {
      this.loading = false;
      this.unobserve();
      // start observing after rerender of products
      this.$nextTick(() => {
        this.observe();
      });
    },
  },
});
</script>
